export default import.meta.ROLLDOWN_FILE_URL("assets/slackLogo-BPEPv-W-.png")